// Originally from giwl-utils.js

export function getCookie(cookieName) {
    var b = document.cookie.match("(^|;)\\s*" + cookieName + "\\s*=\\s*([^;]+)");
    return b ? b.pop() : "";
}
